export default __webpack_public_path__ + "static/media/ÕÉÄÞ¢ªÕ░¥45RGB.47a9275c.jpg";